import { Box, Button, IconButton, Typography } from "@mui/material";
import { formatDateRangeMonthYearAware, getFormattedDate } from "../../../../../common/helpers/formatDateTime";
import { Link, useParams } from "react-router-dom";
import IconWrapper from "../../../../../common/components/functional/icons/IconWrapper";
import { AssignmentById, AssignmentDetails } from "../../../../talents/talentAPI";
import { ArrowRight } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { ReactComponent as EditIcon } from "../../../../../common/icons/editDark.svg";
import { useAppSelector } from "../../../../../app/hooks";

type Props = {
  assignment: AssignmentById;
  canEdit: boolean;
  openSelectDialog: () => void;
};

export const AssignmentRow = ({
  assignment,
  canEdit,
  openSelectDialog,
}: Props) => {
  const { t } = useTranslation();
  const { talentId } = useParams();
  const { tes, workTitle } = useAppSelector((state) => state.localized);

  const renderAssignmentDateRange = (assignmentDetails: AssignmentDetails) => {
    const assignmentEnd = assignmentDetails.end;
    if (assignmentEnd) {
      return formatDateRangeMonthYearAware(
        new Date(assignmentDetails.start),
        // Subtract 1 millisecond to show the correct end date for long assignments
        new Date(assignmentEnd - 1),
        true,
      )
    } else {
      // should never reach this branch as we are working with targetted shifts
      return getFormattedDate(new Date(assignmentDetails.start), false, { date: "dd.MM.yyyy" }) + " - ???"
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        backgroundColor: "#f9f9f9",
        borderRadius: 2,
        width: "100%",
        padding: "8px 12px",
        marginY: 0.5,
      }}
    >
      <Box sx={{ width: "100px" }}>
        {renderAssignmentDateRange(assignment.details)}
      </Box>
      <Box width="200px">{assignment.details.customerOrgName}</Box>
      <Box width="180px">{assignment.details.workLocationName}</Box>
      <Box width="200px">{tes[assignment.details.tesId]}</Box>
      <Box width="120px">{workTitle[assignment.details.workTitleId]}</Box>
      <Box width="80px">
        <Button
          sx={{
            p: 0.5,
          }}
          component={Link}
          to={`/home/talents/${talentId}/assignment/${assignment.assignmentId}`}
          endIcon={
            <ArrowRight
              sx={{
                height: "16px",
                width: "16px",
              }}
            />
          }
        >
          <Typography variant="header" fontWeight="500" fontSize="12px">
            {t("common:additionalInfo")}
          </Typography>
        </Button>
      </Box>
      {canEdit && (
        <Box width="30px">
          <IconButton onClick={openSelectDialog}>
            <IconWrapper
              icon={EditIcon}
              sx={{
                fill: "none",
                stroke: "#000000de",
                width: 14,
                height: 14,
                viewBox: "0 0 24 24",
              }}
            />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
